module.exports = __webpack_public_path__ + "img/gatorz-reviews.3f4007a8.png";